module.exports = __webpack_public_path__ + "img/community_banner.21f65e36.png";